import { render, staticRenderFns } from "./ServicesSchema.vue?vue&type=template&id=4d619f8b&"
import script from "./ServicesSchema.vue?vue&type=script&lang=ts&"
export * from "./ServicesSchema.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports